<template>
  <h1>{{ date }}</h1>
  <h2>{{ verses }}</h2>
  <el-button class="picking-button" @click="getRandom">
    Random picking 5
  </el-button>

  <el-row class="people-area" v-if="randoms.length > 0">
    <el-col :span="4" class="person-name">{{ people[randoms[0]] }}</el-col>
    <el-col :span="1"></el-col>
    <el-col :span="4" class="person-name">{{ people[randoms[1]] }}</el-col>
    <el-col :span="1"></el-col>
    <el-col :span="4" class="person-name">{{ people[randoms[2]] }}</el-col>
    <el-col :span="1"></el-col>
    <el-col :span="4" class="person-name">{{ people[randoms[3]] }}</el-col>
    <el-col :span="1"></el-col>
    <el-col :span="4" class="person-name">{{ people[randoms[4]] }}</el-col>
  </el-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      date: "",
      verses: "",
      people: [],
      randoms: [],
    };
  },
  created() {
    axios
      .get("https://random-picking-default-rtdb.firebaseio.com/date.json")
      .then((res) => {
        this.date = res.data;
      });
    axios
      .get("https://random-picking-default-rtdb.firebaseio.com/verses.json")
      .then((res) => {
        this.verses = res.data;
      });
    axios
      .get("https://random-picking-default-rtdb.firebaseio.com/people.json")
      .then((res) => {
        this.people = res.data;
        // this.people.shift();
      });
  },
  methods: {
    getRandom() {
      let min = Math.ceil(1);
      let max = Math.floor(48);
      this.randoms = [];
      for (let i = 0; i < 5; i++) {
        let rand = Math.floor(Math.random() * (max - min + 1) + min);
        if (this.randoms.includes(rand)) {
          i--;
        } else {
          this.randoms.push(rand);
        }
      }
    },
  },
};
</script>

<style scoped>
.picking-button {
  margin-top: 30px;
  width: 500px;
  height: 100px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 50px;
}

.people-area {
  margin-top: 40px;
}

.person-name {
  font-weight: bold;
  font-size: 30px;
  border: 1px solid black;
  border-radius: 25px;
  padding-top: 25px;
  padding-bottom: 25px;
}
</style>
